// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
.nkl-progress {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: 'tnum';
  display: inline-block;
}
.nkl-progress-line {
  position: relative;
  width: 100%;
  font-size: 14px;
}
.nkl-progress-steps {
  display: inline-block;
}
.nkl-progress-steps-outer {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.nkl-progress-steps-item {
  flex-shrink: 0;
  min-width: 2px;
  margin-right: 2px;
  background: #f3f3f3;
  transition: all 0.3s;
}
.nkl-progress-steps-item-active {
  background: #1890ff;
}
.nkl-progress-small.nkl-progress-line,
.nkl-progress-small.nkl-progress-line .nkl-progress-text .anticon {
  font-size: 12px;
}
.nkl-progress-outer {
  display: inline-block;
  width: 100%;
  margin-right: 0;
  padding-right: 0;
}
.nkl-progress-show-info .nkl-progress-outer {
  margin-right: calc(-2em - 8px);
  padding-right: calc(2em + 8px);
}
.nkl-progress-inner {
  position: relative;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  vertical-align: middle;
  background-color: #f5f5f5;
  border-radius: 100px;
}
.nkl-progress-circle-trail {
  stroke: #f5f5f5;
}
.nkl-progress-circle-path {
  animation: nkl-progress-appear 0.3s;
}
.nkl-progress-inner:not(.nkl-progress-circle-gradient) .nkl-progress-circle-path {
  stroke: #1890ff;
}
.nkl-progress-success-bg,
.nkl-progress-bg {
  position: relative;
  background-color: #1890ff;
  border-radius: 100px;
  transition: all 0.4s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;
}
.nkl-progress-success-bg {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #52c41a;
}
.nkl-progress-text {
  display: inline-block;
  width: 2em;
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 1em;
  line-height: 1;
  white-space: nowrap;
  text-align: left;
  vertical-align: middle;
  word-break: normal;
}
.nkl-progress-text .anticon {
  font-size: 14px;
}
.nkl-progress-status-active .nkl-progress-bg::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  border-radius: 10px;
  opacity: 0;
  animation: nkl-progress-active 2.4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
  content: '';
}
.nkl-progress-status-exception .nkl-progress-bg {
  background-color: #ff4d4f;
}
.nkl-progress-status-exception .nkl-progress-text {
  color: #ff4d4f;
}
.nkl-progress-status-exception .nkl-progress-inner:not(.nkl-progress-circle-gradient) .nkl-progress-circle-path {
  stroke: #ff4d4f;
}
.nkl-progress-status-success .nkl-progress-bg {
  background-color: #52c41a;
}
.nkl-progress-status-success .nkl-progress-text {
  color: #52c41a;
}
.nkl-progress-status-success .nkl-progress-inner:not(.nkl-progress-circle-gradient) .nkl-progress-circle-path {
  stroke: #52c41a;
}
.nkl-progress-circle .nkl-progress-inner {
  position: relative;
  line-height: 1;
  background-color: transparent;
}
.nkl-progress-circle .nkl-progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 1em;
  line-height: 1;
  white-space: normal;
  text-align: center;
  transform: translate(-50%, -50%);
}
.nkl-progress-circle .nkl-progress-text .anticon {
  font-size: 1.16666667em;
}
.nkl-progress-circle.nkl-progress-status-exception .nkl-progress-text {
  color: #ff4d4f;
}
.nkl-progress-circle.nkl-progress-status-success .nkl-progress-text {
  color: #52c41a;
}
@keyframes nkl-progress-active {
  0% {
    transform: translateX(-100%) scaleX(0);
    opacity: 0.1;
  }
  20% {
    transform: translateX(-100%) scaleX(0);
    opacity: 0.5;
  }
  100% {
    transform: translateX(0) scaleX(1);
    opacity: 0;
  }
}
.nkl-progress-rtl {
  direction: rtl;
}
.nkl-progress-rtl.nkl-progress-show-info .nkl-progress-outer {
  margin-right: 0;
  margin-left: calc(-2em - 8px);
  padding-right: 0;
  padding-left: calc(2em + 8px);
}
.nkl-progress-rtl .nkl-progress-success-bg {
  right: 0;
  left: auto;
}
.nkl-progress-rtl.nkl-progress-line .nkl-progress-text,
.nkl-progress-rtl.nkl-progress-steps .nkl-progress-text {
  margin-right: 8px;
  margin-left: 0;
  text-align: right;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
